import { render, staticRenderFns } from "./projectStaff.vue?vue&type=template&id=39daa0be&"
import script from "./projectStaff.vue?vue&type=script&lang=js&"
export * from "./projectStaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports